<template>
    <div class="content">
        <rsk-container title="eラーニング詳細" :buttons="buttons">
            <div class="detail-text-box__header">
                <div class="rsk-flex rsk-items-flex_start">

                    <div>
                        <div class="rsk-page-title rsk-mb-xs">{{tableData.elearningName}}</div>
                        <div class="rsk-flex rsk-items-center rsk-flex_gap-xl rsk-width-max_content">
                            <div class="rsk-text-gray080 rsk-font-l">研修ID：{{tableData.elearningId}}</div>
                            <div class="rsk-flex">
                                <div class="rsk-text-gray080 rsk-font-l">分類・階層：</div>
                                <div class="rsk-font-l rsk-font-bold">
                                    {{elearningType}}
                                </div>
                            </div>
                            <div class="rsk-flex rsk-items-center">
                                <div class="rsk-text-gray080 rsk-font-l">ユーザー評価：</div>
                                <div class="rsk-flex rsk-items-center">
                                    <div v-if="comprehensiveEvaluation == null" class="rsk-font-bold rsk-font-l rsk-mr-xxs">
                                        評価対象外
                                    </div>
                                    <div class="rsk-flex rsk-items-center" v-else>
                                        <div class="rsk-font-bold rsk-font-l rsk-mr-xs">{{comprehensiveEvaluation}}</div>
                                        <div>
                                            <template v-if="starsNum >= 1">
                                                <span class="rsk-icon rsk-icon--star"></span>
                                            </template>
                                            <template v-if="starsNum >= 2">
                                                <span class="rsk-icon rsk-icon--star"></span>
                                            </template>
                                            <template v-if="starsNum >= 3">
                                                <span class="rsk-icon rsk-icon--star"></span>
                                            </template>
                                            <template v-if="starsNum >= 4">
                                                <span class="rsk-icon rsk-icon--star"></span>
                                            </template>
                                            <template v-if="starsNum >= 5">
                                                <span class="rsk-icon rsk-icon--star"></span>
                                            </template>
                                            <template v-if="starsNum < 5">
                                                <span class="rsk-icon rsk-icon--star-border"></span>
                                            </template>
                                            <template v-if="starsNum < 4">
                                                <span class="rsk-icon rsk-icon--star-border"></span>
                                            </template>
                                            <template v-if="starsNum < 3">
                                                <span class="rsk-icon rsk-icon--star-border"></span>
                                            </template>
                                            <template v-if="starsNum < 2">
                                                <span class="rsk-icon rsk-icon--star-border"></span>
                                            </template>
                                            <template v-if="starsNum < 1">
                                                <span class="rsk-icon rsk-icon--star-border"></span>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="rsk-flex rsk-items-center">
                                <template v-if="archiveFlg == 1">
                                    <span class="rsk-icon rsk-icon--archive rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{archiveFlgName}}</span>
                                </template>
                                <template v-else-if="evaluationContent == 1">
                                    <span class="rsk-icon rsk-icon--no1 rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{evaluationContentName}}</span>
                                </template>
                                <template v-else-if="evaluationContent == 2">
                                    <span class="rsk-icon rsk-icon--content10000 rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{evaluationContentName}}</span>
                                </template>
                                <template v-else-if="evaluationContent == 3">
                                    <span class="rsk-icon rsk-icon--hot rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{evaluationContentName}}</span>
                                </template>
                                <template v-else-if="evaluationContent == 4">
                                    <span class="rsk-icon rsk-icon--content5000 rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{evaluationContentName}}</span>
                                </template>
                                <template v-else-if="evaluationContent == 5">
                                    <span class="rsk-icon rsk-icon--like rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{evaluationContentName}}</span>
                                </template>
                                <template v-else-if="evaluationContent == 6">
                                    <span class="rsk-icon rsk-icon--good rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{evaluationContentName}}</span>
                                </template>
                                <template v-else-if="evaluationContent == 7">
                                    <span class="rsk-icon rsk-icon--new rsk-mr-xs"></span>
                                    <span class="rsk-text-green rsk-font-bold">{{evaluationContentName}}</span>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-text-box__content" v-dompurify-html="tableData.elearningInf">
            </div>
            <info-container>
                <info-content label="定価（税抜）" style="display:block">
                    <div class="rsk-text-box__footer-column-right">
                        <div v-if="tableData.fixedPrice == 0" class="rsk-mt-m">0円</div>
                        <div class="rsk-mt-m" v-else-if="tableData.loginRank > tableData.rank" v-text="formatMoney(tableData.fixedPrice) + '円'"></div>
                        <div class="rsk-mt-m" v-else><s v-text="formatMoney(tableData.fixedPrice) + '円'"></s>（ご契約料金内でご利用いただけます）</div>
                    </div>
                </info-content>
                <info-content label="研修期間" style="display:block">
                    <div class="rsk-text-box__footer-column-right">
                        <div class="rsk-mt-m" v-if="tableData.loginRank > tableData.rank">
                            <div v-if="tableData.studyTerm == '0'">期間制限無し</div>
                            <div v-else>{{tableData.studyTerm}}ヶ月</div>
                        </div>
                        <div class="rsk-mt-m" v-else>
                            <div v-if="tableData.studyTerm == '0'">期間制限無し</div>
                            <div v-else><s>{{tableData.studyTerm}}ヶ月</s>（ご契約期間中にご利用いただけます）</div>
                        </div>
                    </div>
                </info-content>
                <info-content :label="'標準学習時間'" style="display:block">
                    <div class="rsk-text-box__footer-column-right">
                        <div class="rsk-mt-m" v-if="tableData.baseStudyTime != '' && tableData.baseStudyTime != null">{{tableData.baseStudyTime}}時間</div>
                    </div>
                </info-content>
            </info-container>
            <div class="rsk-form-control rsk-toggle-form rsk-mb-xs"></div>

            <info-container >
                <info-content label="学習形式" style="display:block">
                    <div class="rsk-text-box__footer-column-right">
                            <div class="rsk-mt-m">
                                <div class="rsk-mr-s">
                                    <div class="rsk-icon-circle-with-text">
                                        <div class="rsk-icon-circle" :style="isHightLight(1, '1') ? '' : 'background-color: #CCCCCC'">
                                            <span class="rsk-icon rsk-icon--white-text"></span>
                                        </div>
                                        <span class="rsk-font-size-xs" :style="isHightLight(1, '1') ? '' : 'color: #CCCCCC'">テキスト</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rsk-mt-m">
                                <div class="rsk-mr-s">
                                    <div class="rsk-icon-circle-with-text">
                                        <div class="rsk-icon-circle" :style="isHightLight(1, '3') ? '' : 'background-color: #CCCCCC'">
                                            <span class="rsk-icon rsk-icon--white-account-square"></span>
                                        </div>
                                        <span class="rsk-font-size-xs" :style="isHightLight(1, '3') ? '' : 'color: #CCCCCC'">アニメーション</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rsk-mt-m">
                                <div class="rsk-mr-s">
                                    <div class="rsk-icon-circle-with-text">
                                        <div class="rsk-icon-circle" :style="isHightLight(1, '2') ? '' : 'background-color: #CCCCCC'">
                                            <span class="rsk-icon rsk-icon--white-movie"></span>
                                        </div>
                                        <span class="rsk-font-size-xs" :style="isHightLight(1, '2') ? '' : 'color: #CCCCCC'">映像</span>
                                    </div>
                                </div>
                            </div>
                    </div>
                </info-content>
                <info-content :label="'研修可能端末'" style="display:block">
                    <div class="rsk-text-box__footer-column-right">
                            <div class="rsk-mt-m">
                                <div class="rsk-mr-s">
                                    <div class="rsk-icon-circle-with-text">
                                        <div class="rsk-icon-circle" :style="isHightLight(2, '1') ? '' : 'background-color: #CCCCCC'">
                                            <span class="rsk-icon rsk-icon--white-pc"></span>
                                        </div>
                                        <span class="rsk-font-size-xs" :style="isHightLight(2, '1') ? '' : 'color: #CCCCCC'">パソコン</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rsk-mt-m">
                                <div class="rsk-mr-s">
                                    <div class="rsk-icon-circle-with-text">
                                        <div class="rsk-icon-circle" :style="isHightLight(2, '2') ? '' : 'background-color: #CCCCCC'">
                                            <span class="rsk-icon rsk-icon--white-mobile"></span>
                                        </div>
                                        <span class="rsk-font-size-xs" :style="isHightLight(2, '2') ? 'b' : 'color: #CCCCCC'">スマートフォン</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rsk-mt-m">
                                <div class="rsk-mr-s">
                                    <div class="rsk-icon-circle-with-text">
                                        <div class="rsk-icon-circle" :style="isHightLight(2, '3') ? '' : 'background-color: #CCCCCC'">
                                            <span class="rsk-icon rsk-icon--white-tablet"></span>
                                        </div>
                                        <span class="rsk-font-size-xs" :style="isHightLight(2, '3') ? '' : 'color: #CCCCCC'">タブレット</span>
                                    </div>
                                </div>
                            </div>
                    </div>
                </info-content>
                <info-content :label="'種別'" style="display:block; height: 104px;">
                    <div class="rsk-text-box__footer-column-right">
                        <template v-for="(specification, index) in tableData.specificationList" :key="index">
                            <div class="rsk-mt-m" v-if="specification == '1'">
                                分割コース<br>
                            </div>
                            <div class="rsk-mt-m" v-else-if="specification == '2'">
                                本文印刷<br>
                            </div>
                        </template>
                    </div>
                </info-content>
            </info-container>

            <div v-if="tableData.imgFileName">
                <div class="rsk-form-control rsk-toggle-form rsk-mb-xs"></div>
                <info-container >
                    <info-content label="画面イメージ" style="display: -webkit-box;">
                        <div class="rsk-mb-xs">
                            <span>画像をクリックすると拡大します</span>
                        </div>
                        <div class="image_file-container small">
                            <img :src="tableData.imgFileName" @click="imgDialogVisible = true" />
                        </div>

                    </info-content>
                </info-container>
            </div>

            <div class="rsk-form-control rsk-toggle-form rsk-mb-xs"></div>
            <div>
                <div>各eラーニングの対応ブラウザ・端末は、動作環境チェックページをご確認の上お申込みください。 （受講にあたりブラウザの対応が限られるコースもございます。） </div>
                <div class="rsk-mt-25">
                    <a href="javascript:void(0);" @click="goEnvironment('/popenvironment')" class="rsk-hover-underline rsk-text-primary">
                        パソコン版はこちら
                    </a>
                </div>
                <div>
                    <a href="javascript:void(0);" @click="goEnvironment('/smt/popenvironment')" class="rsk-hover-underline rsk-text-primary">
                        モバイル版はこちら
                    </a>
                </div>
            </div>

            <el-dialog
                v-model="imgDialogVisible"
                width="1000px"
                :show-close="false"
                >
                <div class="img_dialog-content">
                    <img :src="tableData.imgFileName" />
                </div>
                <rsk-form-submit style="border: none">
                    <div class="rsk-form-button-wrapper__button">
                        <button type="button" class="rsk-button rsk-button--medium rsk-button--expand rsk-button--primary" @click="closeImgDialog">
                            閉じる
                        </button>
                    </div>
                </rsk-form-submit>

            </el-dialog>
        </rsk-container>
    </div>
</template>
<script>
import { ref, onBeforeMount, onMounted, onBeforeUnmount, inject} from 'vue';
import infoContent from "../../component/info-content";
import infoContainer from "../../component/info-container";
import infoHeader from "../../component/info-header";
import { ElMessageBox } from 'element-plus'
import input from '../../../../core/components/rsk/input.vue';
import { useRoute,useRouter } from 'vue-router'
export default {
    components: {
        infoHeader,
        infoContent,
        infoContainer
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const service = inject("service");
        const elearningId = route.params.elearningId;

        const isRecommend = route.params.isRecommend;

        const elearningName = route.params.elearningName;
        const rank = route.params.rank;
        const loginRank = route.params.loginRank;
        const jyukoufukaFlg = ref();
        const priceApplication = route.params.priceApplication;
        const alertMessage = ref();
        const rate = ref(null);
        const tableData = ref([]);
        const elearningType = ref();
        const evaluationContentName = ref("")
        const archiveFlgName = ref("");
        const comprehensiveEvaluation = ref();
        const evaluationContent = ref();
        const archiveFlg = ref();
        const starsNum = ref();
        const fixedPrice = ref();
        const studyTerm = ref();
        const imgDialogVisible = ref(false)
        let goUrl = 'elearning';
        let dispaly37 = false;

        if(!route.params.elearningId) {
            router.push({ name: goUrl, params: {tabSelect: 0, isFromInfo: 1}});
        }
        const buttons = ref({
            left: {
                text: '戻る',
                callBack: function() {
                    router.push({ name: goUrl, params: {tabSelect: 0, isFromInfo: 1}});
                }
            },
            topRight: {
                text: '申し込む',
                callBack: (tableData) => {
                if(jyukoufukaFlg.value == 1){
                    alert("全体管理者または所属組織管理者のため、研修申込できません。");
                    return;
                }
                let formdata = {elearningId: elearningId, elearningName: elearningName, loginRank: loginRank, rank: rank}

                if(priceApplication == "有料" || priceApplication == "有料申込済"){
                    alertMessage.value = "有料の研修のため課金が発生しますが、申込してよろしいでしょうか？ \n" + "定価" + formatMoney(fixedPrice.value) + "円（税抜）、研修期間は"
                    + formatStudyTerm(studyTerm.value) + "です。申込後はキャンセルできません。";
                }else if(priceApplication == "申込済"){
                    alertMessage.value = "「" + elearningName + "」は申込済みです。申込してもよろしいですか？（申込済の研修は「研修管理」から確認できます。）";
                }else{
                    alertMessage.value = "";
                }

                if (alertMessage.value !== "") {
                    ElMessageBox.confirm(alertMessage.value,
                        "研修",{
                            cancelButtonClass: "btn-custom-cancel",
                            confirmButtonText: "OK",
                            cancelButtonText: "キャンセル",
                            type: "warning",
                            customStyle: "white-space: pre-line",
                        }
                        ).then(() => {
                            service.elearningInfo.studyStart(formdata).then((res) => {
                                ElMessageBox({
                                    cancelButtonClass: "btn-custom-cancel",
                                    type:'success',
                                    message: res,
                                    showClose: true,
                                    duration:3000,
                                    showCancelButton: true,
                                    cancelButtonText: "閉じる",
                                    confirmButtonText: '研修を確認する',
                                }).then(() => {
                                    router.push({ name: 'elgstudy', params: {tabSelect: 0, isFromInfo: 1, column: 9, order: '2'}});
                                }).catch(() => {
                                });
                            }).catch((error) => {});
                        }).catch(() => {});
                } else {
                    service.elearningInfo.studyStart(formdata).then((res) => {
                        ElMessageBox({
                            cancelButtonClass: "btn-custom-cancel",
                            type:'success',
                            message: res,
                            showClose: true,
                            duration:3000,
                            showCancelButton: true,
                            cancelButtonText: "閉じる",
                            confirmButtonText: '研修を確認する',
                            }).then(() => {
                                router.push({ name: 'elgstudy', params: {tabSelect: 0, isFromInfo: 1, column: 9, order: '2'}});
                            }).catch(() => {});
                        }).catch((error) => {});
                }
                },
            }
        })
        onMounted(()=>{
            init();
            if(typeof(route.params.fromUrl) != "undefined") {
                goUrl = route.params.fromUrl;
                localStorage.fromTopUrl = goUrl;
            } else if(localStorage.fromTopUrl) {
                goUrl = localStorage.fromTopUrl
            }
        })

        onBeforeUnmount(() => {
            localStorage.removeItem('fromTopUrl')
        })

        function init() {

            let formdata = {elearningId: elearningId, rank: rank, recommendFlg: isRecommend};
            service.elearningInfo.init(formdata).then(res=>{
              jyukoufukaFlg.value = res.jyukoufukaFlg
              dispaly37 = res.dispaly37;
              tableData.value = res.data;
              elearningType.value = tableData.value.elearningTypeName
              evaluationContentName.value = tableData.value.evaluationContentName
              archiveFlgName.value = tableData.value.archiveFlgName;
              comprehensiveEvaluation.value = tableData.value.comprehensiveEvaluation;
              evaluationContent.value = tableData.value.evaluationContent;
              archiveFlg.value = tableData.value.archiveFlg;
              starsNum.value = tableData.value.starsNum;
              fixedPrice.value = tableData.value.fixedPrice;
              studyTerm.value = tableData.value.studyTerm;
              if(!dispaly37){
                buttons.value.centre.show = function() { return false }
              }
            })
        }
        function formatMoney(data) {
            if(data == '' || data == null) {
                return 0;
            } else {
                return (
                (String(data).split(",").join("") || 0)
                    .toString()
                    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","))
                );
            }
        }
        function formatStudyTerm(data) {
            return data == 0 ? "期間制限無し" : "本日から" + data + "ヶ月";
        }
        function closeImgDialog() {
            imgDialogVisible.value = false;
        }
        function goEnvironment(url) {
          window.open(url)
        }
        function isHightLight(flag, val) {

            if (flag == 1) {
                //学習形式
                if (tableData.value.studyTypeList != null) {
                    let index = tableData.value.studyTypeList.indexOf(val)
                    if (index != -1) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }

            } else if(flag == 2) {
                //研修可能端末
                if (tableData.value.environmentList != null) {
                    let index = tableData.value.environmentList.indexOf(val)
                    if (index != -1) {
                        return true
                    }else {
                        return false
                    }
                }
                else {
                    return false
                }

            }
        }
        return { buttons, rate, init, tableData, elearningType, evaluationContentName,archiveFlgName,
            comprehensiveEvaluation, archiveFlg, starsNum, evaluationContent, formatMoney, formatStudyTerm,
            imgDialogVisible, closeImgDialog, goEnvironment, isHightLight
        }
    },
}
</script>
<style scoped>
.container {
    padding-bottom: 16px;
}
.image_file-container {
  max-width: 100%;
}

.image_file-container.small {
  max-width: 500px;
}

.image_file-container.large {
  max-width: 800px;
}

.image_file-container img {
  width: 500px;
  height: auto;
  transition: all 0.3s ease;
}

.image_file-container img:hover {
  cursor: pointer;
  opacity: 0.3;
  background-color: white;
}

.img_dialog-content {
  text-align: center;
}

.img_dialog-content img {
  max-width: 800px;
  height: auto;
}
.rsk-hover-underline:hover {
  text-decoration: underline;
}
</style>
